<div class="popup-overlay">
  <div class="popup-container">
    <div class="header">
      <h2>Welcome to Tuneme</h2>
      <p>Please select your country and language to continue</p>
    </div>
    <div class="logo-container">
      <img src="assets/logo.png" alt="tuneme logo" class="logo">
      <p class="tagline">dream, love & live it</p>
    </div>
    <form [formGroup]="firstVisitForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="countryOffice">Choose Country</label>
        <select id="countryOffice" formControlName="countryOffice">
          <option *ngFor="let country of countries" [ngValue]="country">{{ country.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="language">Choose Language</label>
        <select id="language" formControlName="Current-User-Language">
          <option value="en">en</option>
        </select>
      </div>
      <button type="submit" [disabled]="!firstVisitForm.valid">Continue</button>
    </form>
  </div>
</div>